import {BaseModel} from '@/core/standard/BaseModel';
import {ITableModel, ITables, TableProtocol} from '@/modules/tables/ITableModel';
import TableService from '@/modules/tables/TableService';


const table = {
  name: '',
  qr: '',
  zone_id: '',
  style: ''
};


class TableModel extends BaseModel<ITableModel, TableProtocol, typeof TableService> {
  public modelName = 'Mesa';

  public request = 'JSON';

  constructor() {
    super(table, TableService);
  }

  public async create(data, toast: any = null, toastConfig: any = {}): Promise<boolean> {
    const createValue = await super.create(data, toast, toastConfig);
    return createValue;
  }

  public async update(data, toast: any = null, toastConfig: any = {}): Promise<boolean> {
    const updateValue = await super.update(data, toast, toastConfig);
    // await this.restoreTablesOrder();
    return updateValue;
  }

  // tslint:disable-next-line:max-line-length
  public async delete(data: Array<number | string> | number | string, toast: any = null, toastConfig: any = {}): Promise<boolean> {
    const deleteValue = await super.delete(data, toast, toastConfig);
    return deleteValue;
  }

  public async getTableStyles(data) {
    const response = await this.service.getTableStyles({query: data});
    return response.data.table_style ?? [];
  }

  public async createTableStyles(data) {
    const response = await this.service.createTableStyles({query: {table_style: data}});
    return response.complete;
  }

  public async deleteAllStyles() {
    const response = await this.service.deleteAllStyles({});
    return response.complete;
  }

  public async updateTableStyles(data) {
    const response = await this.service.updateTableStyles({query: data});
    return response.complete;
  }

  public async deleteTableStyles(data) {
    const response = await this.service.deleteTableStyles(data);
    return response.complete;
  }

  public async getTablesListByLocal(protocol: TableProtocol): Promise<any> {
    const response = await this.service.getTablesListByLocal({method: 'GET', ...protocol});
    if (response && response.data) {
      return {
        data: response.data.results,
        total: response.data.total,
      };
    }
    return {data: [], total: 0};
  }

  public async getActiveTables(query) {
    const request = await this.service.getActiveTables({method: 'GET', ...query});
    if (request && request.data) {
      return {data: request.data};
    }
  }
}

export default TableModel as new() => ITables;
